<template>
  <v-container>
    <page-heading>{{ pageTitle }}</page-heading>

    <div class="d-flex justify-end mb-2">
      <v-btn color="primary" @click="showSettlementCreateModal = true"><v-icon left>mdi-book-plus</v-icon>{{ trans('settlement.create') }}</v-btn>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn class="ml-2" v-on="on">{{ trans('general.more') }}<v-icon right>mdi-chevron-down</v-icon></v-btn>
        </template>

        <v-list dense>
          <v-list-item @click="pushToRoute('SettlementPreviewPage')">
            <v-list-item-title><v-icon left small>mdi-book-search-outline</v-icon>{{ trans('settlement.generatePreview') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <settlement-create-modal :show-modal.sync="showSettlementCreateModal"/>
    </div>

    <ajax-table
      ref="settlementsTable"
      :resource="resourceUrl"
      :headers="[
        {text: 'settlement.month', value: 'year'},
        {text: 'settlement.commissionNet', value: 'provisionNet', type: 'currency'},
        {text: 'settlement.commissionGross', value: 'provisionGross', type: 'currency'},
        {text: 'settlement.openCommission', value: 'openCommissionTotal', type: 'currency', sortable: false},
        {text: 'settlement.saldoTotal', value: 'saldoTotal', type: 'currency'},
        {text: 'settlement.status', value: 'status'},
        {text: '', value: 'actions'},
      ]"
      :page-options="{itemsPerPage: 20}"
      :items-per-page-options="[10, 20, 50]"
      @page-loaded="loadLatestOpenCommissionTotal"
    >
      <template v-slot:body.prepend>
        <tr class="open-commissions-preview-row">
          <td class="pl-4">
            <template v-if="latestOpenCommissionTotal && latestOpenCommissionTotal.createdAt !== null">
              {{ getMonthNameByIndex(latestOpenCommissionTotal.month) }} {{ latestOpenCommissionTotal.year }}
            </template>
            <template v-else>&hellip;</template>
          </td>
          <td></td>
          <td></td>
          <td class="py-2">
            <div style="min-height: 2.5rem;">
              <template v-if="latestOpenCommissionTotal && latestOpenCommissionTotal.createdAt !== null">
                <currency-amount :amount="latestOpenCommissionTotal.openCommissionTotal"></currency-amount>
                <div class="subtext" style="font-size: 0.75em;">
                  ({{ trans('settlement.effectiveDate', {date: formatDate(latestOpenCommissionTotal.createdAt, 'L')}) }})
                  <v-icon
                    @click="downloadOpenCommissionCsv"
                    style="display: inline; cursor: pointer;"
                    small color="green"
                    :title="trans('settlement.downloadOpenCommission', {date: formatDate(latestOpenCommissionTotal.openCommissionDate, 'L')})">
                    mdi-file-download-outline
                  </v-icon>
                </div>
              </template>
              <template v-else>&hellip;</template>
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </template>

      <template v-slot:item.year="{item}">
        <settlement-name :settlement="item" :open-in-new-tab="false" />
      </template>

      <template v-slot:item.status="{ item }">
        <settlement-status :settlement="item" />
      </template>

      <template v-slot:item.actions="{ item }">
        <show-icon-button @click="pushToRoute('SettlementDetails', {settlementId: item.id})"></show-icon-button>
      </template>
    </ajax-table>
  </v-container>
</template>

<script>
import AjaxTable from '../components/AjaxTable';
import {LocaleUtils} from '../utils/locale-utils';
import PageHeading from '../components/PageHeading';
import {DateUtils} from '../utils/date-utils';
import {RouterUtils} from '../utils/router-utils';
import ShowIconButton from '../components/ShowIconButton';
import SettlementCreateModal from '../components/SettlementCreateModal';
import {MainUtils} from '@/utils/main-utils';
import CurrencyAmount from '../components/CurrencyAmount';
import {SettlementApi} from "@/api/settlement-api";
import SettlementStatus from '../components/SettlementStatus';
import SettlementName from '../components/SettlementName';

export default {
  name: 'SettlementsPage',
  mixins: [
    LocaleUtils,
    DateUtils,
    RouterUtils,
    MainUtils
  ],
  components: {
    SettlementName,
    SettlementStatus,
    CurrencyAmount,
    SettlementCreateModal,
    ShowIconButton,
    PageHeading,
    AjaxTable
  },
  data: () => ({
    showSettlementCreateModal: false,
    settlementToDelete: null,
    latestOpenCommissionTotal: null
  }),

  computed: {
    resourceUrl () {
      return SettlementApi.apiUri;
    },
    pageTitle () {
      return this.transPlural('settlement.settlement');
    }
  },

  mounted () {
    this.loadLatestOpenCommissionTotal();
  },

  activated () {
    this.$refs.settlementsTable.loadData();
  },

  methods: {
    loadLatestOpenCommissionTotal () {
      SettlementApi.getLatestOpenCommissionTotal()
      .then(response => this.latestOpenCommissionTotal = response.body)
    },
    downloadOpenCommissionCsv () {
      if (!this.latestOpenCommissionTotal) {
        return;
      }
      SettlementApi.downloadOpenCommissionCsv(this.latestOpenCommissionTotal.year, this.latestOpenCommissionTotal.month)
      .then(this.downloadResponseAsFile)
      .catch(this.handleErrorResponse)
    }
  }
}
</script>

<style>
tr.open-commissions-preview-row td {
  background: #F9F9F9;
  color: #888;
  border-bottom: 2px dashed #CCC !important;
}
</style>
